import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'language-name',
  templateUrl: './language-name.component.html',
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class LanguageNameComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;

  getLanguageName(value: any) {
    const date = CONSTANTS_DATA.ALL_LANGUAGES.find(
      (lang) => lang.LANG_CODE === value,
    );
    return date?.LANG_CODE;
  }
}
